import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import customers1 from "../../../images/customers/1.jpg";
import Filter from "../Customer/Filter";
import { getCustomersAction } from '../../../store/actions/customer/CustomerActions';
import TableFooter from '../Common/TableFooter';
import CommonExportButtons from '../Common/CommonExportButtons';
import PageSizeSelector from '../Common/PageSizeSelector';
import SkeletonTable from '../Common/SkeletonTable';

function CustomerListNew() {
  const dispatch = useDispatch();
  const { customers, loading } = useSelector(state => state.customer);
  const totalPages = customers?.pages || 1;
  const customerRows = customers?.rows || [];
  const [openMenu, setOpenMenu] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterQuery, setFilterQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [orderBy, setOrderBy] = useState('');
  const [orderByDir, setOrderByDir] = useState('desc');

  // Define skeleton table columns for customers
  const skeletonColumns = [
    { title: '', width: 20 },
    { title: 'Name', width: 120 },
    { title: 'Phone', width: 80 },
    { title: 'Email', width: 120 },
    { title: 'Joined', width: 100 },
    { title: 'Ads Posted', width: 60 },
    { title: 'Status', width: 60 }
  ];

  const buildSearchQuery = () => {
    const search = searchTerm ? searchTerm : '';
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    if (statusFilter === "blocked") params.append('filter_isEnabled', 'false');
    if (statusFilter === "unblocked") params.append('filter_isEnabled', 'true');
    if (phoneVerified) params.append('filter_isPhoneVerified', 'true');
    if (emailVerified) params.append('filter_isEmailVerified', 'true');
    if (orderBy) {
      params.append('orderBy', orderBy);
      params.append('orderByDir', orderByDir);
    }
    const queryString = `${params.toString()}`;
    return queryString;
  };

  const handleSort = (field) => {
    if (orderBy === field) {
      setOrderByDir(orderByDir === 'desc' ? 'asc' : 'desc');
    } else {
      setOrderBy(field);
      setOrderByDir('desc');
    }
    setCurrentPage(1);
  };

  const onSubmit = async () => {
    const query = buildSearchQuery();
    setFilterQuery(query);
    setCurrentPage(1);
  };


  useEffect(() => {
    let query = buildSearchQuery();
    let effectivePageSize = pageSize;
    if (pageSize === 100000) {
      // 'All' option selected
      query = query ? `${query}&noPagination=true` : 'noPagination=true';
      effectivePageSize = 100000;
    }
    dispatch(getCustomersAction(currentPage, effectivePageSize, "", query));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, currentPage, pageSize, filterQuery, orderBy, orderByDir]);

  return (
    <>
      <div className='form-head page-titles d-flex  align-items-center'>
        <div className='me-auto  d-lg-block'>
          <h4 className='mb-1'>Customer List</h4>
        </div>
      </div>
      <Filter
        setOpenMenu={setOpenMenu}
        openMenu={openMenu}
        onSubmit={onSubmit}
        setSearchTerm={setSearchTerm}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        searchTerm={searchTerm}
        phoneVerified={phoneVerified}
        setPhoneVerified={setPhoneVerified}
        emailVerified={emailVerified}
        setEmailVerified={setEmailVerified}
        resetButtonDisabled={!(searchTerm || statusFilter || orderBy || phoneVerified || emailVerified)}
        onResetButtonClick={() => {
          if (!(searchTerm || statusFilter || orderBy || phoneVerified || emailVerified)) return;
          setSearchTerm('');
          setStatusFilter('');
          setOrderBy('');
          setOrderByDir('desc');
          setPhoneVerified(false);
          setEmailVerified(false);
          setFilterQuery("");
          setCurrentPage(1);
        }}
      />
      
      <div className='row'>
        <div className="d-flex mb-2 align-items-center justify-content-between">
          <PageSizeSelector
            pageSize={pageSize}
            setPageSize={setPageSize}
            setCurrentPage={setCurrentPage}
          />
          <CommonExportButtons
            data={customerRows}
            exportHeaders={[
              { label: 'Name', key: 'name' },
              { label: 'Phone', key: 'phone' },
              { label: 'Email', key: 'email' },
              { label: 'Joined', key: 'createdAt' },
              { label: 'Ads Posted', key: 'adsPosted' },
              { label: 'Status', key: 'isEnabled' },
            ]}
            filename="customers"
            pdfTitle="Customer List"
            totalText="Total Customers"
            pdfOrientation="portrait"
            pdfHeaderColor={[41, 128, 185]}
            dateFields={['createdAt', 'lastLogin']}
          />
        </div>
        <div className='col-xl-12'>
          <div className='table-responsive table-hover fs-14 order-list-table'>
            {loading ? (
              <SkeletonTable columns={skeletonColumns} rows={8} />
            ) : (!loading && customerRows.length === 0) ? (
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 220, width: '100%' }}>
                <div className="card shadow-sm border-0 p-4 text-center w-100" style={{ background: '#f8fafc' }}>
                  <div style={{ fontSize: 48, color: '#adb5bd', marginBottom: 12 }}>
                    <i className="fa fa-search" />
                  </div>
                  <div style={{ fontWeight: 600, fontSize: 20, color: '#495057', marginBottom: 4 }}>
                    No Data Found
                  </div>
                  <div style={{ color: '#868e96', fontSize: 15 }}>
                    Try adjusting your filters or search criteria.
                  </div>
                </div>
              </div>
            ) : (
              <table className='table display table-hover display mb-4 dataTablesCard card-table dataTable no-footer' id='customerTable'>
                <thead>
                  <tr role='row'>
                    {/* <th>
                      <div className='form-check custom-checkbox ms-2'>
                        <input type='checkbox' className='form-check-input' id='checkAll' />
                        <label className='form-check-label' htmlFor='checkAll' />
                      </div>
                    </th> */}
                    <th style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('name')}>
                      Name
                      <span style={{ marginLeft: 4, fontSize: 13, display: 'inline-block', verticalAlign: 'middle' }}>
                        <i className="fa fa-caret-up" style={{ color: orderBy === 'name' && orderByDir === 'asc' ? '#007bff' : '#ccc', opacity: orderBy === 'name' || true ? 1 : 0.5, display: 'block', lineHeight: 1 }} />
                        <i className="fa fa-caret-down" style={{ color: orderBy === 'name' && orderByDir === 'desc' ? '#007bff' : '#ccc', opacity: orderBy === 'name' || true ? 1 : 0.5, display: 'block', lineHeight: 1, marginTop: -2 }} />
                      </span>
                    </th>
                    <th style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('phone')}>
                      Phone
                      <span style={{ marginLeft: 4, fontSize: 13, display: 'inline-block', verticalAlign: 'middle' }}>
                        <i className="fa fa-caret-up" style={{ color: orderBy === 'phone' && orderByDir === 'asc' ? '#007bff' : '#ccc', opacity: orderBy === 'phone' || true ? 1 : 0.5, display: 'block', lineHeight: 1 }} />
                        <i className="fa fa-caret-down" style={{ color: orderBy === 'phone' && orderByDir === 'desc' ? '#007bff' : '#ccc', opacity: orderBy === 'phone' || true ? 1 : 0.5, display: 'block', lineHeight: 1, marginTop: -2 }} />
                      </span>
                    </th>
                    <th style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('email')}>
                      Email
                      <span style={{ marginLeft: 4, fontSize: 13, display: 'inline-block', verticalAlign: 'middle' }}>
                        <i className="fa fa-caret-up" style={{ color: orderBy === 'email' && orderByDir === 'asc' ? '#007bff' : '#ccc', opacity: orderBy === 'email' || true ? 1 : 0.5, display: 'block', lineHeight: 1 }} />
                        <i className="fa fa-caret-down" style={{ color: orderBy === 'email' && orderByDir === 'desc' ? '#007bff' : '#ccc', opacity: orderBy === 'email' || true ? 1 : 0.5, display: 'block', lineHeight: 1, marginTop: -2 }} />
                      </span>
                    </th>
                    <th style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('createdAt')}>
                      Joined
                      <span style={{ marginLeft: 4, fontSize: 13, display: 'inline-block', verticalAlign: 'middle' }}>
                        <i className="fa fa-caret-up" style={{ color: orderBy === 'createdAt' && orderByDir === 'asc' ? '#007bff' : '#ccc', opacity: orderBy === 'createdAt' || true ? 1 : 0.5, display: 'block', lineHeight: 1 }} />
                        <i className="fa fa-caret-down" style={{ color: orderBy === 'createdAt' && orderByDir === 'desc' ? '#007bff' : '#ccc', opacity: orderBy === 'createdAt' || true ? 1 : 0.5, display: 'block', lineHeight: 1, marginTop: -2 }} />
                      </span>
                    </th>
                    <th style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('lastLogin')}>
                      Last Login
                      <span style={{ marginLeft: 4, fontSize: 13, display: 'inline-block', verticalAlign: 'middle' }}>
                        <i className="fa fa-caret-up" style={{ color: orderBy === 'lastLogin' && orderByDir === 'asc' ? '#007bff' : '#ccc', opacity: orderBy === 'lastLogin' || true ? 1 : 0.5, display: 'block', lineHeight: 1 }} />
                        <i className="fa fa-caret-down" style={{ color: orderBy === 'lastLogin' && orderByDir === 'desc' ? '#007bff' : '#ccc', opacity: orderBy === 'lastLogin' || true ? 1 : 0.5, display: 'block', lineHeight: 1, marginTop: -2 }} />
                      </span>
                    </th>
                    <th style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => handleSort('adsPosted')}>
                      Ads Posted
                      <span style={{ marginLeft: 4, fontSize: 13, display: 'inline-block', verticalAlign: 'middle' }}>
                        <i className="fa fa-caret-up" style={{ color: orderBy === 'adsPosted' && orderByDir === 'asc' ? '#007bff' : '#ccc', opacity: orderBy === 'adsPosted' || true ? 1 : 0.5, display: 'block', lineHeight: 1 }} />
                        <i className="fa fa-caret-down" style={{ color: orderBy === 'adsPosted' && orderByDir === 'desc' ? '#007bff' : '#ccc', opacity: orderBy === 'adsPosted' || true ? 1 : 0.5, display: 'block', lineHeight: 1, marginTop: -2 }} />
                      </span>
                    </th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {customerRows.map((item, idx) => (
                    <tr key={item._id}>
                      {/* <td>
                        <div className='form-check custom-checkbox ms-2'>
                          <input type='checkbox' className='form-check-input' id={`customCheckBox${idx}`} />
                          <label className='form-check-label' htmlFor={`customCheckBox${idx}`} />
                        </div>
                      </td> */}
                      <td>
                        <img
                          className="me-sm-2 me-1 img-fluid rounded"
                          width={40}
                          src={item.profilePicture ? item.profilePicture : customers1}
                          alt="Customer"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = customers1;
                          }}
                        />
                        {item.name}
                      </td>
                      <td>{item.phone}</td>
                      <td>{item.email}</td>
                      <td>{moment(item.createdAt).format("DD/MM/YYYY, hh:mm A")}</td>
                      <td>{moment(item.lastLogin).format("DD/MM/YYYY, hh:mm A")}</td>
                      <td>{item.adsPosted}</td>
                      {/* <td>{item.isEnabled ? "Active" : "Blocked"}</td> */}
                      <td>
                        {item.isEnabled ? <span className="badge bg-success">Active</span> : (
                          <span className="badge bg-danger">Blocked</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
      {(!loading && customerRows.length > 0) && (
        <TableFooter
          currentPage={currentPage}
          totalPages={totalPages}
          pageSize={pageSize}
          totalEntries={customers?.total || customerRows.length}
          onPageChange={setCurrentPage}
        />
      )}
    </>
  );
}


export default CustomerListNew;
